// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = () => ({
  // One line, in the host's type: "REF: <id> | Created on <date>". The date gives way first, and
  // goes entirely while an edit is open - the editor's field needs the room, and the date is
  // back the moment the edit closes.
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    minWidth: 0,
    fontSize: 'inherit',
    lineHeight: 'inherit',
    letterSpacing: 'inherit',
    color: 'inherit',
    '&:has(.MuiInputBase-root) .projectReferenceCreated': {
      display: 'none',
    },
  },
  label: {
    fontWeight: 500,
    flexShrink: 0,
  },
  created: {
    minWidth: 0,
    fontSize: 'inherit',
    lineHeight: 'inherit',
    letterSpacing: 'inherit',
    color: 'inherit',
  },
});

export default styles;
